'use stric'
import CookieService from './cookiesService'

var WithToken = {
    getToken: function (name) {
        return !!CookieService.getCookie(name)
            ? JSON.parse(CookieService.getCookie(name)).token
            : false
    },
    isToken: function (name) {
        return !!WithToken.getToken(name) ? true : false
    },
    headersToken: function (object, name) {
        return WithToken.isToken(name)
            ? {
                ...object,
                headers: { 'x-token': WithToken.getToken(name) }
            }
            : object
    },
}

export default WithToken;